import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      {/* Add your content here */}
    </div>
  );
};

export default NotFound;